import { Crumb } from 'contexts/Breadcrumbs/Context';
import { PublicLayout } from 'layouts';
import { serverSidePageFetcher } from 'utils/functions/serverSidePageFetcher';

import { EkardoContentPage } from 'components';

const crumbs: Crumb[] = [
  {
    title: 'Privacy Policy',
    route: '/privacy-policy',
  },
];

export async function getServerSideProps(context) {
  const { page, pageId } = await serverSidePageFetcher('privacy', context);
  return { props: { page, pageId } };
}

function PrivacyPolicy({ page }) {
  return (
    <PublicLayout title="Privacy policy - OurFutures" description="The OurFutures site privacy policy." crumbs={crumbs}>
      {page.map(({ id: sectionId, sectionContainers, contentLayoutId, backgroundColor: sectionBackgroundColor }, index) => {
        return (
          <EkardoContentPage
            contentLayoutId={contentLayoutId}
            index={index}
            sectionBackgroundColor={sectionBackgroundColor}
            sectionContainers={sectionContainers}
            sectionId={sectionId}
          />
        );
      })}
    </PublicLayout>
  );
}

export default PrivacyPolicy;
